module.exports = __webpack_public_path__ + "static/img/no-account-icon.98b73b0c.png";